export function getTracesSampleRate(env?: string): number {
	return env === 'production' ? 0.1 : 1.0;
}

export const REPLAY_SESSION_SAMPLE_RATE = 0.1;
export const REPLAY_ON_ERROR_SAMPLE_RATE = 1.0;
